import { ReactNode, useState, createContext, useContext } from 'react';

type NotificationContentOverrideContextType = {
  notificationContentOverride: string | null
  setNotificationContentOverride: (value: string | null) => void
};

const NotificationContentOverrideContext = createContext<NotificationContentOverrideContextType | undefined>(undefined)

export function useNotificationContentOverride() {
  const context = useContext(NotificationContentOverrideContext)
  if (!context) {
    throw new Error('useNotificationContentOverride must be used within a NotificationContentOverrideProvider')
  }
  return context
}


type NotificationContentOverrideProviderProps = {
  children: ReactNode;
}

export function NotificationContentOverrideProvider({ children }: NotificationContentOverrideProviderProps) {
  const [notificationContentOverride, setNotificationContentOverride] = useState<string | null>(null)

  return (
    <NotificationContentOverrideContext.Provider value={{ notificationContentOverride, setNotificationContentOverride }}>
      {children}
    </NotificationContentOverrideContext.Provider>
  );
}
